import Entity from "./entity";

class Order extends Entity {
  constructor(data) {
    super(data);

    this.cash = this.cash || null;
    this.date = this.convertDate(data.date);
    this.created = this.convertDate(data.created);
  }
}

export default Order;



// WEBPACK FOOTER //
// ./client/domain/order.js